import instanceQuery from '../../queries/product/StockTakeQuery.graphql';
import workspaceQuery from '../../queries/product/StockTakeWorkspaceQuery.graphql';
import mutationQuery from '../../mutations/product/StockTakeMutation.graphql';
import temporaryMutationQuery from '../../mutations/product/StockTakeTemporaryMutation.graphql';
import fragment from '../../fragments/product/StockTakeFragment.graphql';
import listQuery from '../../queries/product/StockTakeListQuery.graphql';
import { IDocumentConfig, ReportType } from '../../schema/p4types';
import { EntityType } from '../../../@types/entityTypes';
import { workspaceActionsForPermissions } from './StockTakeLine';
import { IWorkspaceAction } from '../../../@types/workspaceTypes';
import { StockTakeAction } from '../../../components/StockTakeHeader/StockTakeHeader';
import { IEditableDataGridAction } from '../../../components/view/UseEditableDataGridViewController';

export const workspaceActionsForPermissionsStockTake: Array<IWorkspaceAction> = [
  { actionReference: StockTakeAction.Post },
  { actionReference: StockTakeAction.Save },
  { actionReference: StockTakeAction.AddProducts },
  { actionReference: StockTakeAction.AddNewLocation },
  { actionReference: StockTakeAction.ImportLines },
  { actionReference: StockTakeAction.Clear },
  { actionReference: StockTakeAction.Delete },
  { actionReference: StockTakeAction.Variance },
  { actionReference: StockTakeAction.ActivateToggle },
  { actionReference: StockTakeAction.ChangeStatus },
  { actionReference: IEditableDataGridAction.ManageViews },
];

const StockTake: EntityType & { oldFormUrl: string; oldWorkspaceUrl: string } = {
  type: 'StockTake',
  title: 'Stock Take',
  formTitle: 'Stock Take',
  formUrl: '/Products/StockControl/StockTake/',
  oldFormUrl: '/Products/StockControl/OldStockTake/',
  workspaceUrl: '/Products/StockControl/StockTake/Workspace',
  oldWorkspaceUrl: '/Products/StockControl/OldStockTake/Workspace',
  instance: instanceQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  workspace: workspaceQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'reference',
  },
  fragment,
  screenReference: 'PRODUCTS_STOCK_CONTROL_STOCK_TAKE',
  configuration: {
    title: 'Print Stock Take Report',
    reportType: ReportType.StockTakeReport,
    field: undefined as unknown as keyof IDocumentConfig, //There's no defaults configurable for stock take, so cheating a bit here.
  },
  actions: [...workspaceActionsForPermissions, ...workspaceActionsForPermissionsStockTake],
};

export default StockTake;
